export const MAP_EVENT_TYPE = {
  turn: 'turn',
  skillUse: 'skill_use',
  itemUse: 'item_use',
  damage: 'damage',
  heal: 'heal',
  hpChange: 'hp_change',
  move: 'move',
  animation: 'animation',
  entityDied: 'entity_died',
  spawnMobLoot: 'spawn_mob_loot',
  intentFailed: 'intent_failed',
  queueCleared: 'queue_cleared',
} as const;

export type MapEventType = typeof MAP_EVENT_TYPE[keyof typeof MAP_EVENT_TYPE];

export interface MapEventData {
  readonly eventId: string;
  readonly eventType: MapEventType;
  readonly instanceId: string;
  readonly mapId: string;
  readonly sourceId: string;
  readonly targetId: string;
  readonly skillId: string;
  readonly amount: number;
  readonly targetHp: number;
  readonly targetMaxHp: number;
  readonly sourceX: number;
  readonly sourceY: number;
  readonly targetX: number;
  readonly targetY: number;
  readonly snap: boolean;
  readonly payloadJson: string;
  readonly tick: number;
  readonly createdAt: Date;
}

export function coerceMapEventType(value: unknown): MapEventType {
  switch (value) {
    case MAP_EVENT_TYPE.turn:
      return MAP_EVENT_TYPE.turn;
    case MAP_EVENT_TYPE.skillUse:
      return MAP_EVENT_TYPE.skillUse;
    case MAP_EVENT_TYPE.itemUse:
      return MAP_EVENT_TYPE.itemUse;
    case MAP_EVENT_TYPE.damage:
      return MAP_EVENT_TYPE.damage;
    case MAP_EVENT_TYPE.heal:
      return MAP_EVENT_TYPE.heal;
    case MAP_EVENT_TYPE.hpChange:
      return MAP_EVENT_TYPE.hpChange;
    case MAP_EVENT_TYPE.move:
      return MAP_EVENT_TYPE.move;
    case MAP_EVENT_TYPE.animation:
      return MAP_EVENT_TYPE.animation;
    case MAP_EVENT_TYPE.entityDied:
      return MAP_EVENT_TYPE.entityDied;
    case MAP_EVENT_TYPE.spawnMobLoot:
      return MAP_EVENT_TYPE.spawnMobLoot;
    case MAP_EVENT_TYPE.queueCleared:
      return MAP_EVENT_TYPE.queueCleared;
    case MAP_EVENT_TYPE.intentFailed:
      return MAP_EVENT_TYPE.intentFailed;
    default:
      return MAP_EVENT_TYPE.skillUse;
  }
}
